export default "__VITE_ASSET__BLRECaKN__"